import { IProductInformationSection } from "@faire/web-api/indigofair/data/IProductInformationSection";

export const transformListOfItemsInMultiLinedText = (
  listOfItems: string[],
  renderingFormat: keyof typeof IProductInformationSection.Format | undefined
) => {
  return renderingFormat === IProductInformationSection.Format.BULLET_LIST
    ? listOfItems.map((str) => `•  ${str}`).join("\n")
    : listOfItems.join("\n");
};
